// import React from "react";
// const InputField = ({
//   type,
//   onChange,
//   extraClass,
//   name,
//   id,
//   label,
//   value,
//   placeholder,
//   togglePassword,
//   iconDisplaye,
//   passwordIcon,
// }) => {
//   return (
//     <>
//       <div className="field">
//         <input
//           className={`${extraClass}`}
//           type={type}
//           name={name}
//           id={id}
//           onChange={onChange}
//           value={value}
//           autoComplete="off"
//           placeholder={placeholder}
//           required
//         />
//         <label title={label} data-title={label}></label>

//         {passwordIcon && (
//           <div className="password-icon">
//             {!iconDisplaye ? (
//               <img
//                 onClick={togglePassword}
//                 src="./assets/icons/view-icon.svg"
//                 alt="icon"
//               />
//             ) : (
//               <img
//                 onClick={togglePassword}
//                 src="./assets/icons/view-icon1.svg"
//                 alt="icon"
//               />
//             )}
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default InputField;

import React from "react";

const InputField = ({
  type,
  onChange,
  extraClass,
  name,
  id,
  label,
  value,
  disabled,
  readOnly,
  placeholder,
  togglePassword,
  iconDisplayed,
  passwordIcon,
}) => {
  return (
    <div className="field">
      <input
        className={extraClass}
        type={type}
        name={name}
        id={id}
        onChange={onChange}
        value={value} // Ensure value is always provided
        autoComplete="off"
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        required
      />
      <label title={label} data-title={label}></label>

      {passwordIcon && (
        <div className="password-icon">
          <img
            onClick={togglePassword}
            src={
              iconDisplayed
                ? "./images/icons/close-eye.svg"
                : "./images/icons/view-icon.svg"
            }
            alt="icon"
          />
        </div>
      )}
    </div>
  );
};

export default InputField;
